<div class="bg-login">
    <div class="login-content"></div>
    <div class="login-el">
        <div class="login-box">
            <div class="logo-content">
                <img src="../../assets/img/image 3.png" class="img-login" />
            </div>
            <div class="mg-t">
                <div class="line-t"></div>
                <span class="text-signin">{{
                    "GLOBAL.SIGN_IN" | translate
                }}</span>
                <div class="line-t"></div>
            </div>
            <div>
                <div *ngIf="error">
                    <div class="error-box">
                        {{ error }}
                    </div>
                </div>
                <form
                    [formGroup]="loginFormf"
                    #loginfForm="ngForm"
                    (ngSubmit)="onLogin()"
                >
                    <div
                        class="input-area input-group"
                        style="margin-bottom: 18px"
                    >
                        <div class="text-input">
                            {{ "GLOBAL.USERNAME" | translate }}
                        </div>
                        <input
                            class="input-t"
                            (keydown.enter)="onLogin()"
                            formControlName="username"
                            type="text"
                            [class.is-invalid]="
                                (loginfForm.submitted &&
                                    loginFormf.get('username')?.invalid) ||
                                (loginFormf.get('username').touched &&
                                    loginFormf.get('username')?.invalid)
                            "
                        />
                        <div></div>
                        <div></div>
                        <div class="input-error">
                            <img
                                src="../../assets/icons/input-warning.svg"
                                style="
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 4px;
                                "
                            />Enter username
                        </div>
                    </div>
                    <div class="input-area">
                        <div class="text-input">
                            {{ "GLOBAL.PASSWORD" | translate }}
                        </div>
                        <div class="input-group">
                            <input
                                class="input-t"
                                type="text"
                                (keydown.enter)="onLogin()"
                                formControlName="password"
                                [type]="showPassC1 ? 'text' : 'password'"
                                [class.is-invalid]="
                                    (loginfForm.submitted &&
                                        loginFormf.get('password')?.invalid) ||
                                    (loginFormf.get('password').touched &&
                                        loginFormf.get('password')?.invalid)
                                "
                            />
                            <div
                                class="pass-addon"
                                (click)="showPassC1 = !showPassC1"
                            >
                                <img
                                    *ngIf="!showPassC1"
                                    src="../../assets/icons/eye-open.svg"
                                    style="width: 22px; height: 22px"
                                />
                                <img
                                    *ngIf="showPassC1"
                                    src="../../assets/icons/eye-close.svg"
                                    style="width: 22px; height: 22px"
                                />
                            </div>
                            <div></div>
                            <div></div>
                            <div class="input-error">
                                <img
                                    src="../../assets/icons/input-warning.svg"
                                    style="
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 4px;
                                    "
                                />Enter current password
                            </div>
                        </div>
                    </div>

                    <div>
                        <button class="sign-bt">
                            {{ "GLOBAL.SIGN_IN" | translate }}
                        </button>
                    </div>
                    <div class="text-right">v {{ version }}</div>
                </form>
            </div>
            <!-- <div class="fg-bc">
        <a href="" class="fg-pass">Forgot password ?</a>
      </div> -->
        </div>
    </div>
</div>
